export const clamp = (val, min, max) => {
    return Math.max(min, Math.min(val, max));
};
//# sourceMappingURL=clamp.js.map
// @zapier/design-system@6.27.0 (617a97f69)
